import { fetchApi } from "../../tools";

export const get = async({...props}) => {
    
    const { url, opcion, headers } = props;
    try {
        const response = await fetchApi({
            url: url,
            headers: headers,
            content: opcion
        })
        return response
    } catch (error) {
        return error
    }
}

export const post = async({...props}) => {
    
    const { url, opcion, headers } = props;
    try {
        const response = await fetchApi({
            method: 'POST',
            url: url,
            headers: headers,
            content: opcion
        })
        return response
    } catch (error) {
        return error
    }
}